import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PersonLockFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="personLockFilled" ref={ref} {...props}>
    <path d="M9.51,11.06a4.16,4.16,0,1,1,4.15-4.15A4.16,4.16,0,0,1,9.51,11.06Zm11.33,4.62V13.92a2.62,2.62,0,0,0-2.62-2.62H17.6A2.62,2.62,0,0,0,15,13.92v1.76a2.74,2.74,0,0,0-1.91,2.62V20a2.75,2.75,0,0,0,2.75,2.75H20A2.75,2.75,0,0,0,22.75,20V18.3A2.74,2.74,0,0,0,20.84,15.68Zm-4.36-1.76A1.12,1.12,0,0,1,17.6,12.8h.62a1.12,1.12,0,0,1,1.12,1.12v1.63H16.48Zm-4.65-.5H6.28c-2.79,0-5.06,3.27-5.06,6.06a.67.67,0,0,0,.66.67h9.27V16.37a2,2,0,0,1,2-2v-.69A3.49,3.49,0,0,0,11.83,13.42Z" />
  </Icon>
)) as IconWithRender;

PersonLockFilledIcon.displayName = 'PersonLockFilledIcon';
PersonLockFilledIcon.renderIcon = (props) => (
  <PersonLockFilledIcon {...props} />
);
export default PersonLockFilledIcon;
